"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMsem = getMsem;
const chemical_elements_1 = require("chemical-elements");
function getMsem(em, charge) {
    if (charge > 0) {
        return em / charge - chemical_elements_1.ELECTRON_MASS;
    }
    else if (charge < 0) {
        return em / (charge * -1) + chemical_elements_1.ELECTRON_MASS;
    }
    else {
        return 0;
    }
}
//# sourceMappingURL=getMsem.js.map